// @generated by protoc-gen-es v2.0.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/uploads/v2/service.proto (package creativefabrica.uploads.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { UploadApp, UploadAppJson, UploadState, UploadStateJson } from "./types_pb";
import { file_creativefabrica_uploads_v2_types } from "./types_pb";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/uploads/v2/service.proto.
 */
export const file_creativefabrica_uploads_v2_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_uploads_v2_types, file_google_api_annotations]);

/**
 * @generated from message creativefabrica.uploads.v2.CompleteVoDMultipartUploadRequest
 */
export type CompleteVoDMultipartUploadRequest = Message<"creativefabrica.uploads.v2.CompleteVoDMultipartUploadRequest"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.CompletePartEtag parts = 2;
   */
  parts: CompletePartEtag[];

  /**
   * @generated from field: string key = 3;
   */
  key: string;

  /**
   * @generated from field: string s3_upload_id = 4;
   */
  s3UploadId: string;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.CompleteVoDMultipartUploadRequest.
 */
export type CompleteVoDMultipartUploadRequestJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.CompletePartEtag parts = 2;
   */
  parts?: CompletePartEtagJson[];

  /**
   * @generated from field: string key = 3;
   */
  key?: string;

  /**
   * @generated from field: string s3_upload_id = 4;
   */
  s3UploadId?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.CompleteVoDMultipartUploadRequest.
 * Use `create(CompleteVoDMultipartUploadRequestSchema)` to create a new message.
 */
export const CompleteVoDMultipartUploadRequestSchema: GenMessage<CompleteVoDMultipartUploadRequest, CompleteVoDMultipartUploadRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 0);

/**
 * @generated from message creativefabrica.uploads.v2.CompletePartEtag
 */
export type CompletePartEtag = Message<"creativefabrica.uploads.v2.CompletePartEtag"> & {
  /**
   * @generated from field: int32 part_number = 1;
   */
  partNumber: number;

  /**
   * @generated from field: string etag = 2;
   */
  etag: string;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.CompletePartEtag.
 */
export type CompletePartEtagJson = {
  /**
   * @generated from field: int32 part_number = 1;
   */
  partNumber?: number;

  /**
   * @generated from field: string etag = 2;
   */
  etag?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.CompletePartEtag.
 * Use `create(CompletePartEtagSchema)` to create a new message.
 */
export const CompletePartEtagSchema: GenMessage<CompletePartEtag, CompletePartEtagJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 1);

/**
 * @generated from message creativefabrica.uploads.v2.CompleteVoDMultipartUploadResponse
 */
export type CompleteVoDMultipartUploadResponse = Message<"creativefabrica.uploads.v2.CompleteVoDMultipartUploadResponse"> & {
};

/**
 * JSON type for the message creativefabrica.uploads.v2.CompleteVoDMultipartUploadResponse.
 */
export type CompleteVoDMultipartUploadResponseJson = {
};

/**
 * Describes the message creativefabrica.uploads.v2.CompleteVoDMultipartUploadResponse.
 * Use `create(CompleteVoDMultipartUploadResponseSchema)` to create a new message.
 */
export const CompleteVoDMultipartUploadResponseSchema: GenMessage<CompleteVoDMultipartUploadResponse, CompleteVoDMultipartUploadResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 2);

/**
 * @generated from message creativefabrica.uploads.v2.InitiateVoDMultipartUploadRequest
 */
export type InitiateVoDMultipartUploadRequest = Message<"creativefabrica.uploads.v2.InitiateVoDMultipartUploadRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadApp app = 3;
   */
  app: UploadApp;

  /**
   * @generated from field: int64 expires_in = 4;
   */
  expiresIn: bigint;

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata: { [key: string]: string };
};

/**
 * JSON type for the message creativefabrica.uploads.v2.InitiateVoDMultipartUploadRequest.
 */
export type InitiateVoDMultipartUploadRequestJson = {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize?: string;

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadApp app = 3;
   */
  app?: UploadAppJson;

  /**
   * @generated from field: int64 expires_in = 4;
   */
  expiresIn?: string;

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.uploads.v2.InitiateVoDMultipartUploadRequest.
 * Use `create(InitiateVoDMultipartUploadRequestSchema)` to create a new message.
 */
export const InitiateVoDMultipartUploadRequestSchema: GenMessage<InitiateVoDMultipartUploadRequest, InitiateVoDMultipartUploadRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 3);

/**
 * @generated from message creativefabrica.uploads.v2.InitiateVoDMultipartUploadResponse
 */
export type InitiateVoDMultipartUploadResponse = Message<"creativefabrica.uploads.v2.InitiateVoDMultipartUploadResponse"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: int64 part_size = 2;
   */
  partSize: bigint;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.PartUploadUrl urls = 3;
   */
  urls: PartUploadUrl[];

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadState state = 4;
   */
  state: UploadState;

  /**
   * @generated from field: map<string, string> input_form_fields = 5;
   */
  inputFormFields: { [key: string]: string };

  /**
   * @generated from field: string key = 6;
   */
  key: string;

  /**
   * @generated from field: string s3_upload_id = 7;
   */
  s3UploadId: string;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.InitiateVoDMultipartUploadResponse.
 */
export type InitiateVoDMultipartUploadResponseJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: int64 part_size = 2;
   */
  partSize?: string;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.PartUploadUrl urls = 3;
   */
  urls?: PartUploadUrlJson[];

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadState state = 4;
   */
  state?: UploadStateJson;

  /**
   * @generated from field: map<string, string> input_form_fields = 5;
   */
  inputFormFields?: { [key: string]: string };

  /**
   * @generated from field: string key = 6;
   */
  key?: string;

  /**
   * @generated from field: string s3_upload_id = 7;
   */
  s3UploadId?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.InitiateVoDMultipartUploadResponse.
 * Use `create(InitiateVoDMultipartUploadResponseSchema)` to create a new message.
 */
export const InitiateVoDMultipartUploadResponseSchema: GenMessage<InitiateVoDMultipartUploadResponse, InitiateVoDMultipartUploadResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 4);

/**
 * @generated from message creativefabrica.uploads.v2.PartUploadUrl
 */
export type PartUploadUrl = Message<"creativefabrica.uploads.v2.PartUploadUrl"> & {
  /**
   * @generated from field: int32 part_number = 1;
   */
  partNumber: number;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.PartUploadUrl.
 */
export type PartUploadUrlJson = {
  /**
   * @generated from field: int32 part_number = 1;
   */
  partNumber?: number;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.PartUploadUrl.
 * Use `create(PartUploadUrlSchema)` to create a new message.
 */
export const PartUploadUrlSchema: GenMessage<PartUploadUrl, PartUploadUrlJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 5);

/**
 * @generated from message creativefabrica.uploads.v2.InitiateMultipartUploadRequest
 */
export type InitiateMultipartUploadRequest = Message<"creativefabrica.uploads.v2.InitiateMultipartUploadRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize: bigint;

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadApp app = 4;
   */
  app: UploadApp;

  /**
   * @generated from field: int64 expires_in = 5;
   */
  expiresIn: bigint;

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: int64 part_size = 7;
   */
  partSize: bigint;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.InitiateMultipartUploadRequest.
 */
export type InitiateMultipartUploadRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize?: string;

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadApp app = 4;
   */
  app?: UploadAppJson;

  /**
   * @generated from field: int64 expires_in = 5;
   */
  expiresIn?: string;

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: int64 part_size = 7;
   */
  partSize?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.InitiateMultipartUploadRequest.
 * Use `create(InitiateMultipartUploadRequestSchema)` to create a new message.
 */
export const InitiateMultipartUploadRequestSchema: GenMessage<InitiateMultipartUploadRequest, InitiateMultipartUploadRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 6);

/**
 * @generated from message creativefabrica.uploads.v2.InitiateMultipartUploadResponse
 */
export type InitiateMultipartUploadResponse = Message<"creativefabrica.uploads.v2.InitiateMultipartUploadResponse"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: int64 part_size = 2;
   */
  partSize: bigint;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.PartUploadUrl urls = 3;
   */
  urls: PartUploadUrl[];

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadState state = 4;
   */
  state: UploadState;

  /**
   * @generated from field: string key = 5;
   */
  key: string;

  /**
   * @generated from field: string s3_upload_id = 6;
   */
  s3UploadId: string;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.InitiateMultipartUploadResponse.
 */
export type InitiateMultipartUploadResponseJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: int64 part_size = 2;
   */
  partSize?: string;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.PartUploadUrl urls = 3;
   */
  urls?: PartUploadUrlJson[];

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadState state = 4;
   */
  state?: UploadStateJson;

  /**
   * @generated from field: string key = 5;
   */
  key?: string;

  /**
   * @generated from field: string s3_upload_id = 6;
   */
  s3UploadId?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.InitiateMultipartUploadResponse.
 * Use `create(InitiateMultipartUploadResponseSchema)` to create a new message.
 */
export const InitiateMultipartUploadResponseSchema: GenMessage<InitiateMultipartUploadResponse, InitiateMultipartUploadResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 7);

/**
 * @generated from message creativefabrica.uploads.v2.CompleteMultipartUploadRequest
 */
export type CompleteMultipartUploadRequest = Message<"creativefabrica.uploads.v2.CompleteMultipartUploadRequest"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.CompletePartEtag parts = 2;
   */
  parts: CompletePartEtag[];

  /**
   * @generated from field: string key = 3;
   */
  key: string;

  /**
   * @generated from field: string s3_upload_id = 4;
   */
  s3UploadId: string;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.CompleteMultipartUploadRequest.
 */
export type CompleteMultipartUploadRequestJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.CompletePartEtag parts = 2;
   */
  parts?: CompletePartEtagJson[];

  /**
   * @generated from field: string key = 3;
   */
  key?: string;

  /**
   * @generated from field: string s3_upload_id = 4;
   */
  s3UploadId?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.CompleteMultipartUploadRequest.
 * Use `create(CompleteMultipartUploadRequestSchema)` to create a new message.
 */
export const CompleteMultipartUploadRequestSchema: GenMessage<CompleteMultipartUploadRequest, CompleteMultipartUploadRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 8);

/**
 * @generated from message creativefabrica.uploads.v2.CompleteMultipartUploadResponse
 */
export type CompleteMultipartUploadResponse = Message<"creativefabrica.uploads.v2.CompleteMultipartUploadResponse"> & {
};

/**
 * JSON type for the message creativefabrica.uploads.v2.CompleteMultipartUploadResponse.
 */
export type CompleteMultipartUploadResponseJson = {
};

/**
 * Describes the message creativefabrica.uploads.v2.CompleteMultipartUploadResponse.
 * Use `create(CompleteMultipartUploadResponseSchema)` to create a new message.
 */
export const CompleteMultipartUploadResponseSchema: GenMessage<CompleteMultipartUploadResponse, CompleteMultipartUploadResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 9);

/**
 * @generated from message creativefabrica.uploads.v2.CreateDirectVoDUploadUrlRequest
 */
export type CreateDirectVoDUploadUrlRequest = Message<"creativefabrica.uploads.v2.CreateDirectVoDUploadUrlRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadApp app = 3;
   */
  app: UploadApp;

  /**
   * @generated from field: int64 expires_in = 4;
   */
  expiresIn: bigint;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };
};

/**
 * JSON type for the message creativefabrica.uploads.v2.CreateDirectVoDUploadUrlRequest.
 */
export type CreateDirectVoDUploadUrlRequestJson = {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize?: string;

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadApp app = 3;
   */
  app?: UploadAppJson;

  /**
   * @generated from field: int64 expires_in = 4;
   */
  expiresIn?: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.uploads.v2.CreateDirectVoDUploadUrlRequest.
 * Use `create(CreateDirectVoDUploadUrlRequestSchema)` to create a new message.
 */
export const CreateDirectVoDUploadUrlRequestSchema: GenMessage<CreateDirectVoDUploadUrlRequest, CreateDirectVoDUploadUrlRequestJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 10);

/**
 * @generated from message creativefabrica.uploads.v2.CreateDirectVoDUploadUrlResponse
 */
export type CreateDirectVoDUploadUrlResponse = Message<"creativefabrica.uploads.v2.CreateDirectVoDUploadUrlResponse"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadState state = 3;
   */
  state: UploadState;

  /**
   * @generated from field: map<string, string> input_form_fields = 4;
   */
  inputFormFields: { [key: string]: string };
};

/**
 * JSON type for the message creativefabrica.uploads.v2.CreateDirectVoDUploadUrlResponse.
 */
export type CreateDirectVoDUploadUrlResponseJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;

  /**
   * @generated from field: creativefabrica.uploads.v2.UploadState state = 3;
   */
  state?: UploadStateJson;

  /**
   * @generated from field: map<string, string> input_form_fields = 4;
   */
  inputFormFields?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.uploads.v2.CreateDirectVoDUploadUrlResponse.
 * Use `create(CreateDirectVoDUploadUrlResponseSchema)` to create a new message.
 */
export const CreateDirectVoDUploadUrlResponseSchema: GenMessage<CreateDirectVoDUploadUrlResponse, CreateDirectVoDUploadUrlResponseJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_service, 11);

/**
 * @generated from service creativefabrica.uploads.v2.UploadsService
 */
export const UploadsService: GenService<{
  /**
   * @generated from rpc creativefabrica.uploads.v2.UploadsService.CreateDirectVoDUploadUrl
   */
  createDirectVoDUploadUrl: {
    methodKind: "unary";
    input: typeof CreateDirectVoDUploadUrlRequestSchema;
    output: typeof CreateDirectVoDUploadUrlResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.uploads.v2.UploadsService.InitiateVoDMultipartUpload
   */
  initiateVoDMultipartUpload: {
    methodKind: "unary";
    input: typeof InitiateVoDMultipartUploadRequestSchema;
    output: typeof InitiateVoDMultipartUploadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.uploads.v2.UploadsService.CompleteVoDMultipartUpload
   */
  completeVoDMultipartUpload: {
    methodKind: "unary";
    input: typeof CompleteVoDMultipartUploadRequestSchema;
    output: typeof CompleteVoDMultipartUploadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.uploads.v2.UploadsService.InitiateMultipartUpload
   */
  initiateMultipartUpload: {
    methodKind: "unary";
    input: typeof InitiateMultipartUploadRequestSchema;
    output: typeof InitiateMultipartUploadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.uploads.v2.UploadsService.CompleteMultipartUpload
   */
  completeMultipartUpload: {
    methodKind: "unary";
    input: typeof CompleteMultipartUploadRequestSchema;
    output: typeof CompleteMultipartUploadResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_uploads_v2_service, 0);

